/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedRapportagesRouteImport } from './routes/_authenticated/rapportages'
import { Route as AuthenticatedMailboxRouteImport } from './routes/_authenticated/mailbox'
import { Route as AuthenticatedIncassozakenRouteImport } from './routes/_authenticated/incassozaken'
import { Route as AuthenticatedFacturenRouteImport } from './routes/_authenticated/facturen'
import { Route as AuthenticatedActiesRouteImport } from './routes/_authenticated/acties'
import { Route as AuthenticatedDebiteurenIndexRouteImport } from './routes/_authenticated/debiteuren/index'
import { Route as AuthenticatedDebiteurenDebtorNumberRouteImport } from './routes/_authenticated/debiteuren/$debtorNumber'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedRapportagesRoute =
  AuthenticatedRapportagesRouteImport.update({
    id: '/rapportages',
    path: '/rapportages',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMailboxRoute = AuthenticatedMailboxRouteImport.update({
  id: '/mailbox',
  path: '/mailbox',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedIncassozakenRoute =
  AuthenticatedIncassozakenRouteImport.update({
    id: '/incassozaken',
    path: '/incassozaken',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFacturenRoute = AuthenticatedFacturenRouteImport.update({
  id: '/facturen',
  path: '/facturen',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedActiesRoute = AuthenticatedActiesRouteImport.update({
  id: '/acties',
  path: '/acties',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDebiteurenIndexRoute =
  AuthenticatedDebiteurenIndexRouteImport.update({
    id: '/debiteuren/',
    path: '/debiteuren/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDebiteurenDebtorNumberRoute =
  AuthenticatedDebiteurenDebtorNumberRouteImport.update({
    id: '/debiteuren/$debtorNumber',
    path: '/debiteuren/$debtorNumber',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/acties': typeof AuthenticatedActiesRoute
  '/facturen': typeof AuthenticatedFacturenRoute
  '/incassozaken': typeof AuthenticatedIncassozakenRoute
  '/mailbox': typeof AuthenticatedMailboxRoute
  '/rapportages': typeof AuthenticatedRapportagesRoute
  '/debiteuren/$debtorNumber': typeof AuthenticatedDebiteurenDebtorNumberRoute
  '/debiteuren/': typeof AuthenticatedDebiteurenIndexRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/login': typeof LoginRoute
  '/acties': typeof AuthenticatedActiesRoute
  '/facturen': typeof AuthenticatedFacturenRoute
  '/incassozaken': typeof AuthenticatedIncassozakenRoute
  '/mailbox': typeof AuthenticatedMailboxRoute
  '/rapportages': typeof AuthenticatedRapportagesRoute
  '/': typeof AuthenticatedIndexRoute
  '/debiteuren/$debtorNumber': typeof AuthenticatedDebiteurenDebtorNumberRoute
  '/debiteuren': typeof AuthenticatedDebiteurenIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/acties': typeof AuthenticatedActiesRoute
  '/_authenticated/facturen': typeof AuthenticatedFacturenRoute
  '/_authenticated/incassozaken': typeof AuthenticatedIncassozakenRoute
  '/_authenticated/mailbox': typeof AuthenticatedMailboxRoute
  '/_authenticated/rapportages': typeof AuthenticatedRapportagesRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/debiteuren/$debtorNumber': typeof AuthenticatedDebiteurenDebtorNumberRoute
  '/_authenticated/debiteuren/': typeof AuthenticatedDebiteurenIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/'
    | '/login'
    | '/acties'
    | '/facturen'
    | '/incassozaken'
    | '/mailbox'
    | '/rapportages'
    | '/debiteuren/$debtorNumber'
    | '/debiteuren/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/login'
    | '/acties'
    | '/facturen'
    | '/incassozaken'
    | '/mailbox'
    | '/rapportages'
    | '/'
    | '/debiteuren/$debtorNumber'
    | '/debiteuren'
  id:
    | '__root__'
    | '/$'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/acties'
    | '/_authenticated/facturen'
    | '/_authenticated/incassozaken'
    | '/_authenticated/mailbox'
    | '/_authenticated/rapportages'
    | '/_authenticated/'
    | '/_authenticated/debiteuren/$debtorNumber'
    | '/_authenticated/debiteuren/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/rapportages': {
      id: '/_authenticated/rapportages'
      path: '/rapportages'
      fullPath: '/rapportages'
      preLoaderRoute: typeof AuthenticatedRapportagesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/mailbox': {
      id: '/_authenticated/mailbox'
      path: '/mailbox'
      fullPath: '/mailbox'
      preLoaderRoute: typeof AuthenticatedMailboxRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/incassozaken': {
      id: '/_authenticated/incassozaken'
      path: '/incassozaken'
      fullPath: '/incassozaken'
      preLoaderRoute: typeof AuthenticatedIncassozakenRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/facturen': {
      id: '/_authenticated/facturen'
      path: '/facturen'
      fullPath: '/facturen'
      preLoaderRoute: typeof AuthenticatedFacturenRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/acties': {
      id: '/_authenticated/acties'
      path: '/acties'
      fullPath: '/acties'
      preLoaderRoute: typeof AuthenticatedActiesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/debiteuren/': {
      id: '/_authenticated/debiteuren/'
      path: '/debiteuren'
      fullPath: '/debiteuren/'
      preLoaderRoute: typeof AuthenticatedDebiteurenIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/debiteuren/$debtorNumber': {
      id: '/_authenticated/debiteuren/$debtorNumber'
      path: '/debiteuren/$debtorNumber'
      fullPath: '/debiteuren/$debtorNumber'
      preLoaderRoute: typeof AuthenticatedDebiteurenDebtorNumberRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedActiesRoute: typeof AuthenticatedActiesRoute
  AuthenticatedFacturenRoute: typeof AuthenticatedFacturenRoute
  AuthenticatedIncassozakenRoute: typeof AuthenticatedIncassozakenRoute
  AuthenticatedMailboxRoute: typeof AuthenticatedMailboxRoute
  AuthenticatedRapportagesRoute: typeof AuthenticatedRapportagesRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedDebiteurenDebtorNumberRoute: typeof AuthenticatedDebiteurenDebtorNumberRoute
  AuthenticatedDebiteurenIndexRoute: typeof AuthenticatedDebiteurenIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedActiesRoute: AuthenticatedActiesRoute,
  AuthenticatedFacturenRoute: AuthenticatedFacturenRoute,
  AuthenticatedIncassozakenRoute: AuthenticatedIncassozakenRoute,
  AuthenticatedMailboxRoute: AuthenticatedMailboxRoute,
  AuthenticatedRapportagesRoute: AuthenticatedRapportagesRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedDebiteurenDebtorNumberRoute:
    AuthenticatedDebiteurenDebtorNumberRoute,
  AuthenticatedDebiteurenIndexRoute: AuthenticatedDebiteurenIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
